/**
 * Request ID Generator
 * Generates UUID v4 for tracking requests across frontend and backend
 */

/**
 * Generate a UUID v4 compliant request ID
 * @returns {string} UUID v4 string
 */
export const generateRequestId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

/**
 * Validate if a string is a valid UUID v4
 * @param {string} uuid - String to validate
 * @returns {boolean} True if valid UUID v4
 */
export const isValidUUID = (uuid) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};



